import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const faqKeys = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9'] as const;

export default function FAQ() {
  const { t } = useTranslation();

  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <motion.h1
        className="font-display text-4xl font-bold mb-10"
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
      >
        {t('faq.title')}
      </motion.h1>

      <div className="space-y-2">
        {faqKeys.map((key, i) => (
          <motion.details
            key={key}
            className="group bg-surface border border-border rounded-lg overflow-hidden"
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.35, delay: i * 0.05 }}
          >
            <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-surface-hover transition-colors list-none">
              <span className="font-medium text-sm">{t(`faq.items.${key}`)}</span>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-muted flex-shrink-0 transition-transform group-open:rotate-180">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </summary>
            <div className="px-5 pb-4 text-sm text-muted leading-relaxed">{t(`faq.items.a${key.slice(1)}`)}</div>
          </motion.details>
        ))}
      </div>
    </div>
  );
}
